import { render, staticRenderFns } from "./ReceivableCard.vue?vue&type=template&id=4b2b5911&scoped=true"
import script from "./ReceivableCard.vue?vue&type=script&lang=js"
export * from "./ReceivableCard.vue?vue&type=script&lang=js"
import style0 from "./ReceivableCard.vue?vue&type=style&index=0&id=4b2b5911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b5911",
  null
  
)

export default component.exports